import React from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { Button, Card, CardActions, CardContent } from '@mui/material';
import { useSelector } from 'react-redux';
import * as authService from '../services/auth';
import routes from '../routes';
import { getRescuerSitePausedAt } from '../helpers/user';

const PausedRescuerNotification = () => {
  const history = useHistory();
  const user = authService.getCurrentlyLoggedInOrImpersonatingUser();
  const isDrawerOpen = useSelector((state) => state.ui.persisted.isDrawerOpen);
  const site = useSelector((state) => state.app.site);

  const paddingLeftValueAboveSmBreakpoint = (() => {
    if (user && !authService.shouldHideMainDrawer(user)) {
      return isDrawerOpen ? '235px' : '70px';
    }

    return '16px';
  })();

  const onProfile = () => {
    history.push(generatePath(routes.profile));
  };

  if (!site || !getRescuerSitePausedAt(user, site.id)) {
    return null;
  }

  return (
    <Card
      sx={{
        backgroundColor: '#e1ebfd',
        width: '100%',
        paddingLeft: { xs: 0, sm: paddingLeftValueAboveSmBreakpoint },
      }}
    >
      <CardContent style={{ paddingBottom: 0 }}>
        <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Rescuing is paused</div>

        <div style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.54)' }}>
          You can&apos;t claim rescues until you have resumed rescuing. To do it visit your profile and resume it there.
        </div>
      </CardContent>

      <CardActions>
        <Button size="small" color="primary" variant="contained" onClick={onProfile}>
          Visit Profile
        </Button>
      </CardActions>
    </Card>
  );
};

export default PausedRescuerNotification;
